import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token =
    localStorage.getItem("access") || sessionStorage.getItem("access");

  if (!token) {
    return <Navigate to="/login-register" replace />;
  }

  return children;
};

export default PrivateRoute;
